import type { BankName } from '@/shared/types/base';

const bankIconUrls = import.meta.glob<string>('@/assets/bank-icons/*.svg', {
  eager: true,
  query: '?url',
  import: 'default',
});

export function getBankIconUrl(bankName: BankName, full = false): string {
  const suffix = full ? '-icon-full.svg' : '-icon.svg';
  const path = Object.keys(bankIconUrls).find((key) => key.endsWith(`/${bankName}${suffix}`));

  return path ? bankIconUrls[path] : '';
}
